export default __webpack_public_path__ + "static/media/Saly-35.6cd66235.png";